<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<el-page-header @back="goBack" content="学员学习记录信息"></el-page-header>
			<div class="row-me row-center margin-top20" >
				<el-collapse class="width100Per" v-model="activeNames" >
					<el-collapse-item title="学员基础信息" name="1" v-if="dataInfo != null">
						<el-descriptions  style="width: 100%;" :column = "4" border>
							<el-descriptions-item label="头像">
								<el-image v-if="dataInfo.avatar == null" class="avatarBox" :src="require('@/assets/images/user_avatar.png')"></el-image>
								<el-image v-else class="avatarBox" :src="dataInfo.avatar"></el-image>
							</el-descriptions-item>
							<el-descriptions-item label="生日">{{dataInfo.birthday}}</el-descriptions-item>
							<el-descriptions-item label="性别">{{dataInfo.sex}}</el-descriptions-item>
							<el-descriptions-item label="年龄">{{dataInfo.ageText}}岁</el-descriptions-item>
							
							<el-descriptions-item label="姓名">{{dataInfo.name}} </el-descriptions-item>
							<el-descriptions-item label="手机号">{{dataInfo.phone}}</el-descriptions-item>
							
							<el-descriptions-item label="昵称">{{dataInfo.nickname}}</el-descriptions-item>
							<el-descriptions-item label="年级">{{dataInfo.grade_text}}</el-descriptions-item>
							<el-descriptions-item label="地区">{{dataInfo.area_text}}</el-descriptions-item>
							<el-descriptions-item label="签名">{{dataInfo.signature}}</el-descriptions-item>
						</el-descriptions>
					</el-collapse-item>
				</el-collapse>
			</div>
			<div class="column-me flex1 overflow-auto margin-top20">
				<div class="flex1 overflow-auto">
					<el-tabs v-model="tabActiveName" type="border-card">
					    <el-tab-pane label="今日学习时长" name="first">
							<el-table :data="TodayStudyTime" :highlight-current-row="false" :show-header="false" v-loading="loading" size="medium" style="width: 100%" height="100%">
								<el-table-column prop="label" label="" width="100" align="center" show-overflow-tooltip></el-table-column>
								<el-table-column prop="dailyProportion" label=""   align="center" show-overflow-tooltip>
									<template #default="scope">
										<el-progress :percentage="scope.row.dailyProportion"></el-progress>
									</template>
								</el-table-column>
								<el-table-column prop="studyTime" label="" width="200" align="center" show-overflow-tooltip></el-table-column>
							</el-table>
						</el-tab-pane>
					    <el-tab-pane label="7日内学习时长" name="second">
							<el-tabs v-model="sevenActiveName" @tab-click="handleClick">
							    <el-tab-pane v-for="(item,index) in userSubjectList" :key="index" :label="item.label" :name="index" :data-id="item.id"></el-tab-pane>
							</el-tabs>
							<el-table :data="SevenStudyTime" :highlight-current-row="false" :show-header="false" v-loading="loading" size="medium" style="width: 100%" height="100%">
								<el-table-column prop="mateInfo" label="" width="100" align="center" show-overflow-tooltip></el-table-column>
								<el-table-column prop="dailyProportion" label="" align="center" show-overflow-tooltip>
									<template #default="scope">
										<el-progress :percentage="scope.row.dailyProportion"></el-progress>
									</template>
								</el-table-column>
								<el-table-column prop="studyTime" label="" width="200" align="center" show-overflow-tooltip></el-table-column>
							</el-table>
						</el-tab-pane>
					    <el-tab-pane label="总时长" name="third">
							<el-table :data="AllStudyTime" :highlight-current-row="false" :show-header="false" v-loading="loading" size="medium" style="width: 100%" height="100%">
								<el-table-column prop="label" label="" width="100" align="center" show-overflow-tooltip></el-table-column>
								<el-table-column prop="dailyProportion" label=""   align="center" show-overflow-tooltip>
									<template #default="scope">
										<el-progress :percentage="scope.row.dailyProportion"></el-progress>
									</template>
								</el-table-column>
								<el-table-column prop="studyTime" label="" width="200" align="center" show-overflow-tooltip></el-table-column>
							</el-table>
						</el-tab-pane>
					  </el-tabs>
				</div>
				
			</div>
		</div>
	</div>
	
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
export default {
  components: {Plus,Search},
  data() {
    return {
		user_id:0,
		dataInfo:null,
		loading:true,
		allloading:true,
		TodayStudyTime: [],
		userSubjectList:[],
		SevenStudyTime: [],
		AllStudyTime: [],
		activeNames:['1'],
		sevenActiveName:0,
		tabActiveName:'first'
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {
    Search() {
      return Search
    }
  },
  // html加载完成之前
  created() {
  },
  // html加载完成后执行。
  mounted() {
	this.user_id = this.$route.query.user_id;
	if(this.user_id != 0){
		this.getStudentInfo();
		this.getTodayStudyTime();
		this.getUserAllStudyTime();
	}
	//console.log(this.id);
  },
  // 事件方法执行
	methods: {
		goBack(){
		  this.$router.go(-1)
		},
		handleClick(tab, event) {
		    //console.log(tab, event);
			console.log(tab.props.name);
			this.getUserSevenStudyTime(this.userSubjectList[tab.props.name].id);
		},
		//跳转课时详情
		goStudentSpecialTaskList(obj,user_id){
			this.$router.push({
				name:'studentSpecialTaskList',
				query:{
					id:obj,
					user_id:user_id
				}
			})
		},
		//获取用户今日学习时长统计
		getTodayStudyTime() {
			this.loading = true;
			this.$post('/admin/userTodayStudyTime', {
				user_id: this.user_id,
			}).then((res) => {
				if (res) {
					//console.log(res.data);
					this.TodayStudyTime = res.data;
					this.loading = false;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//获取用户今日学习时长统计
		getUserAllStudyTime() {
			this.allloading = true;
			this.$post('/admin/userAllStudyTime', {
				user_id: this.user_id,
			}).then((res) => {
				if (res) {
					//console.log(res.data);
					this.AllStudyTime = res.data;
					this.allloading = false;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//获取用户7日内学习时长统计
		getUserSevenStudyTime(subject_id) {
			this.allloading = true;
			this.$post('/admin/userSevenDayStudyTime', {
				user_id: this.user_id,
				subject_id: subject_id
			}).then((res) => {
				if (res) {
					this.SevenStudyTime = res.data;
					this.allloading = false;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//获取用户信息数据
		getStudentInfo(){
			this.$post('/admin/studentInfo', {
				id: this.user_id
			}).then((res) => {
				if (res) {
					console.log(res.data);
					this.dataInfo = res.data;
					if(this.dataInfo.grade_id != 0){
						this.getUserSubjectList(this.dataInfo.grade_id,this.dataInfo.id);
					}else{
						this.$message.error('该用户未选择年级信息');
					}
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//获取学生初中or高中科目信息
		getUserSubjectList(grade_id,user_id){
			this.$post('/admin/getUserSubjectList', {
				grade_id: grade_id,
				user_id: user_id,
			}).then((res) => {
				if (res) {
					console.log(res.data);
					this.userSubjectList = res.data;
					this.getUserSevenStudyTime(this.userSubjectList[0].id);
				}
			}).catch((error) => {
				console.log(error)
			})
		}
		
	},
}
</script>

<style lang="scss" scoped>
.userList {
	height: 100%;
	.avatarBox{
		width: 40px;
		height: 40px;
		border-radius: 20px;
		overflow: hidden;
	}
	.specialTitle{
		float: left;
		width: 100%;
		height: 40px;
		text-align: left;
		line-height: 40px;
		font-size: 18px;
		color: #555555;
		// background-color: aquamarine;
	}
	.specialStudy{
		float: left;
		width: 100%;
		height: 30px;
		text-align: left;
		line-height: 30px;
		font-size: 16px;
		color: #555555;
		// background-color: antiquewhite;
	}
	.startTimeBox{
		float: left;
		width: 100%;
		height: 30px;
		text-align: left;
		line-height: 30px;
		font-size: 14px;
		color: #555555;
		// background-color: aquamarine;
	}
	.stemTitle{
		//float: left;
		width: 100% !important;
		font-size: 14px;
		font-weight: bold;
		height: 40px;
		overflow: hidden;
		line-height: 40px;
	}
	.stemClass{
		font-size: 14px;
		line-height: 30px;
		font-weight: bold;
		height: auto;
		overflow: hidden;
		color: #000000;
		span{
			float: left;
		}
		.setmImage{
			float: left;
			//margin-left: calc(50% - 180px);
			width: 80%;
			height: 225px;
			overflow: hidden;
		}
		.optionClass{
			display: block;
			font-size: 14px;
			font-weight: 500;
			line-height: 30px;
			height: auto;
			width: 100%;
			padding: 0px 10px 0px 0px;
			.optionImageTitle{
				float: left;
				width: 30px;
				line-height: 225px;
				height: 225px;
			}
			
		}
	}
	.stemClass .optionClass .optionImage{
				float: left;
				width: 360px;
				height: 225px;
			}
	.stemClass .optionClass .optionImage .el-image{
		width: 360px;
		height: 225px;
		overflow: hidden;
	}	
	.setmAnswer{
		font-size: 14px;
		line-height: 40px;
		background-color: #f4f4f5;
		color: #909399;
		padding: 0px 20px 0px 20px;
	}
	.setmBrief{
		float: left;
		width: 100%;
		overflow: hidden;
	}
	.setmBrief img{
		width: 500px;
		height: auto;
	}
	
	
	
}
</style>
